import { Capacitor } from '@capacitor/core';

// Abrir WhatsApp directo, sin pasar por la página intermedia de wa.me.
//
// DENTRO DE LAS APPS (Capacitor) se usa el esquema whatsapp://: Capacitor
// delega al sistema operativo los esquemas que no son http(s), así que abre
// la app de una, sin el "Continuar al chat" de por medio.
//
// EN LA WEB NO. Safari no tiene a quién delegarle un esquema que no resuelve
// y corta la navegación con "no se puede abrir la página porque la dirección
// no es válida" —un error en pantalla en vez del chat—. Y no hace falta:
// wa.me es universal link en iOS y app link en Android, o sea que con
// WhatsApp instalado abre la app igual de directo. La página intermedia solo
// aparece en escritorio, que es justo donde corresponde.

// Saca número y texto de un enlace de WhatsApp (wa.me o api.whatsapp.com).
// Devuelve null si la url no es de WhatsApp.
export function parsearEnlaceWhatsapp(url) {
  const u = String(url || '');
  if (!/wa\.me|api\.whatsapp\.com|whatsapp:\/\//i.test(u)) return null;

  let numero = '';
  let texto = '';
  try {
    const parsed = new URL(u.replace(/^whatsapp:\/\//i, 'https://whatsapp.local/'));
    texto = parsed.searchParams.get('text') || '';
    numero = (parsed.searchParams.get('phone') || '').replace(/\D/g, '');
    if (!numero) {
      // wa.me/<numero>
      numero = (parsed.pathname || '').replace(/\D/g, '');
    }
  } catch {
    const m = u.match(/wa\.me\/(\d+)/i);
    if (m) numero = m[1];
  }
  return { numero, texto };
}

export function construirEnlaceWebWhatsapp(numero, texto) {
  const q = texto ? `?text=${encodeURIComponent(texto)}` : '';
  return numero ? `https://wa.me/${numero}${q}` : `https://wa.me/${q}`;
}

// Intenta abrir la app; si tras un momento seguimos acá (no está instalada),
// cae al enlace web para no dejar al usuario sin nada.
export function abrirWhatsapp(numero, texto, alFallar) {
  const num = String(numero || '').replace(/\D/g, '');
  // Se reconstruye desde los dígitos: así se limpian los "+57..." que el dueño
  // escribe a mano, que wa.me no acepta en la ruta.
  const webUrl = construirEnlaceWebWhatsapp(num, texto);

  const abrirWeb = () => {
    if (typeof alFallar === 'function') alFallar(webUrl);
    else window.open(webUrl, '_blank');
  };

  // Sin número no hay chat que abrir por esquema, y en la web el esquema ni se
  // intenta (ver la nota de arriba).
  if (!num || !Capacitor.isNativePlatform()) {
    abrirWeb();
    return;
  }

  const params = [`phone=${num}`];
  if (texto) params.push(`text=${encodeURIComponent(texto)}`);
  const appUrl = `whatsapp://send?${params.join('&')}`;

  // Si tras un momento seguimos acá, WhatsApp no está instalado: cae al
  // enlace web para no dejar al usuario sin nada.
  let salio = false;
  const marcarSalida = () => { if (document.hidden) salio = true; };
  document.addEventListener('visibilitychange', marcarSalida);

  window.location.href = appUrl;

  setTimeout(() => {
    document.removeEventListener('visibilitychange', marcarSalida);
    if (salio || document.hidden) return;
    abrirWeb();
  }, 1400);
}
